<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 150px;" type="text" v-model="formInline.PhoneNo" placeholder="手机号码">
				<span slot="prepend">手机号码</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 150px;" type="text" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 150px;" type="text" v-model="formInline.ChargeCardNo" placeholder="卡号/VIN">
				<span slot="prepend">卡号/VIN</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem label="交易类型" :label-width="70" prop="trackName">
			<Select placeholder="交易类型" style="width: 120px;" v-model="formInline.TransactionType">
				<Option :value='0'>全部</Option>
				<Option :value='1'>充值</Option>
				<Option :value='2'>退款</Option>
				<Option :value='3'>消费</Option>
				<Option :value='4'>赠送</Option>
				<Option :value='11'>即时支付充值</Option>
				<Option :value='12'>即时支付消费</Option>
				<Option :value='13'>即时支付退款</Option>
			</Select>
		</FormItem>
		<FormItem label="选择时间" :label-width='70'>
			<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
				v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
		</FormItem>
		<!-- <FormItem label="开始时间" :label-width='100'>
			<DatePicker style="width: 120px;" type="date" placeholder="开始时间" v-model="formInline.TimeBegin">
			</DatePicker>
		</FormItem> -->
		<!-- <FormItem label="结束时间" :label-width='100'>
			<DatePicker style="width: 120px;" type="date" placeholder="结束时间" v-model="formInline.TimeEnd">
			</DatePicker>
		</FormItem> -->
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">查询</Button>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('exportFile')" v-if="hasWidgets('export')">导出文件</Button>
		</FormItem>
	</Form>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					MemberId: '',
					MemberName: '',
					ChargeCardNo: '',
					TransactionType: 0,
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					Source: 1,
				}
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		mounted() {
			// console.log(dateFormat);
			// this.formInline.TimeBegin = dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd');
			// this.formInline.TimeEnd = dateFormat.formatDate(new Date(), 'yyyy-MM-dd');
			// // this.formInline.TimeRange = [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()];
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		},
	}
</script>

<style>
</style>
